export default "__VITE_ASSET__4ac7e79e__"